import { render, staticRenderFns } from "./EmergencyContacts.vue?vue&type=template&id=5d5e12b2&"
import script from "./EmergencyContacts.vue?vue&type=script&lang=js&"
export * from "./EmergencyContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports